import React from 'react'
import { isEmpty } from 'lodash'

import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

// components
import Data from './Data'
import Actions from './Actions'
import AnchorBar from '../AnchorBar'

// mixins
import { SubHeaderContainer, StickyBackground } from './mixins'

export interface ComponentProps {
  aviso: {
    empresa: {
      cantidadAvisos: number
      confidencial: boolean
      denominacion: string
      descripcion: string | null
      id: string
      inclusiva: boolean
      logoURL: string
      videoUrl: string | null
      gptwUrl: string | null
    }
    id: string
    titulo: string
    aptoDiscapacitados: boolean
    origenAviso: string
    seoFriendlyUrl: string
  }
  applicant: object
  setVisibleModal?: Function
  isNavResized: boolean
  productoLookAndFeel: object
  visibleId?: any
  guardado?: boolean
  showAnchorPostular?: boolean
  postulacionRapida?: boolean
}

const Component = ({
  aviso,
  applicant,
  setVisibleModal = () => {},
  isNavResized,
  productoLookAndFeel,
  visibleId,
  guardado,
  showAnchorPostular,
  postulacionRapida,
}: ComponentProps) => {
  const inclusiveCompany = aviso?.empresa.inclusiva
  const isUserLoggedIn = !!applicant
  const { isMobile, isTabletPortrait, isDesktop, isTabletLandscape } = useWindowSize()
  const isTabletLandscapeToDesktop = window.outerWidth >= 1024 && window.outerWidth <= 1200
  const isZonaJobs = aviso && aviso.origenAviso === 'ZONAJOBS'

  return (
    <>
      <SubHeaderContainer
        id="header-component"
        hasLogo={!isEmpty(aviso?.empresa.logoURL)}
        inclusiveCompany={inclusiveCompany}
        productoLookAndFeel={productoLookAndFeel}
        isNavResized={isNavResized}
      >
        <Data aviso={aviso} isZonaJobs={isZonaJobs} />

        {(isTabletLandscapeToDesktop || isTabletLandscape || isDesktop) && (
          <Actions
            aviso={aviso}
            guardado={guardado}
            isUserLoggedIn={isUserLoggedIn}
            setVisibleModal={setVisibleModal}
            showAnchorPostular={showAnchorPostular}
            productoLookAndFeel={productoLookAndFeel}
            postulacionRapida={postulacionRapida}
          />
        )}

        {(isMobile || isTabletPortrait) && !isTabletLandscapeToDesktop && (
          <AnchorBar aviso={aviso} isNavResized={isNavResized} visibleId={visibleId} />
        )}
      </SubHeaderContainer>

      {isNavResized && <StickyBackground />}
    </>
  )
}

export default Component
